/**
 * Helper functions for image alt text management
 * Ensures all images have locale-specific alt text for SEO and accessibility
 */

/**
 * Normalize partner name to match translation key
 * Maps displayed names to translation keys
 */
export function normalizePartnerName(name: string): string {
  const mapping: Record<string, string> = {
    'Lightspeed': 'lightspeed',
    'unTill': 'untill',
    'Bork': 'bork',
    'Oracle': 'oracle',
    'Deliverect': 'deliverect',
    'MplusKASSA': 'mpluskassa',
    'Trivec': 'trivec',
    'Gastrofix': 'gastrofix',
    'NuvoPOS': 'nuvopos',
    'Vectron': 'vectron',
    'Twelve': 'twelve',
    'NCR Aloha': 'ncr-aloha',
    'CashDesk': 'cashdesk',
    'Mr. Winston': 'mr-winston',
    'Hypersoft': 'hypersoft',
  };

  return mapping[name] || name.toLowerCase().replace(/\s+/g, '-');
}

/**
 * Get venue type translation key from image path
 * Maps image filenames to translation keys
 */
export function getVenueKeyFromImage(imagePath: string): string {
  const mapping: Record<string, string> = {
    '/images/venues/cafe-v2.webp': 'cafes',
    '/images/venues/restaurant-v2.webp': 'restaurants',
    '/images/venues/events-v2.webp': 'events',
    '/images/venues/beach-v2.webp': 'beach',
    '/images/venues/parks-v2.webp': 'parks',
    '/images/venues/hotels-v2.webp': 'hotels',
    '/images/venues/bowling-v2.webp': 'bowling',
    '/images/venues/golf-v2.webp': 'golf',
    '/images/venues/zoo-v2.webp': 'zoo',
    '/images/venues/airports-v2.webp': 'airports',
    '/images/venues/hospitals-v2.webp': 'hospitals',
    '/images/venues/theaters-v2.webp': 'theaters',
    '/images/venues/amusement-v2.webp': 'amusement',
    '/images/venues/stadium-v2.webp': 'stadium',
    '/images/venues/fastfood-v2.webp': 'fastfood',
    '/images/venues/foodhall-v2.webp': 'foodhall',
    '/images/venues/buffet-v2.webp': 'buffet',
    '/images/venues/lunchroom-v2.webp': 'lunchroom',
    '/images/venues/bakery-v2.webp': 'bakery',
    '/images/venues/foodtruck-v2.webp': 'foodtruck',
    '/images/venues/catering-v2.webp': 'catering',
    '/images/venues/cruise-v2.webp': 'cruise',
    '/images/venues/casino-v2.webp': 'casino',
    '/images/venues/spa-v2.webp': 'spa',
    '/images/venues/museum-v2.webp': 'museum',
    '/images/venues/congress-v2.webp': 'congress',
    '/images/venues/concert-v2.webp': 'concert',
    '/images/venues/ferry-v2.webp': 'ferry',
    '/images/venues/expo-v2.webp': 'expo',
    '/images/venues/canteen-v2.webp': 'canteen',
    '/images/venues/university-v2.webp': 'university',
    '/images/venues/icecream-v2.webp': 'icecream',
  };

  return mapping[imagePath] || '';
}

/**
 * Get product type translation key
 */
export function getProductTypeKey(productType: 'kiosk' | 'tablet' | 'qr' | 'webshop'): string {
  return productType;
}
